export class ServerError extends Error {
  constructor(message?: string) {
    super(message);

    this.name = 'ServerError';

    if (Error.captureStackTrace) Error.captureStackTrace(this, ServerError);
  }
}
